/**
 * SQL Intelligence Source Map — indicates which queries have
 * Distilled-GenAI patterns (fast, no LLM) vs require LLM.
 *
 * Key = trigger keyword from the query text
 * Value = 'distilled' (fast path) or 'llm' (needs LLM call)
 *
 * This mirrors server/services/genai_fast_path.py PRODUCT_PATTERNS
 */

// Restaurant.Type-1 distilled patterns (fast path keywords)
const RESTAURANT_DISTILLED = [
  'revenue', 'order type', 'sales', 'income', 'channel',
  'top item', 'best seller', 'popular', 'menu', 'what sells',
  'inventory', 'stock', 'reorder', 'low stock', 'supply',
  'daily', 'today', 'this week', 'recent sales',
  'staff', 'employee', 'performance', 'rating', 'team',
  'reservation', 'booking', 'table', 'guest',
  'mobile', 'website', 'walk-in', 'phone', 'delivery app',
  'trend', 'monthly', 'over time', 'growth', 'history',
];

// Gym.Type-1 distilled patterns
const GYM_DISTILLED = [
  'member', 'how many', 'total member', 'active member', 'membership',
  'revenue', 'income', 'sales', 'earnings',
  'class', 'attendance', 'schedule', 'booking', 'session',
  'equipment', 'maintenance', 'machine', 'repair',
  'check-in', 'checkin', 'visit', 'traffic', 'daily', 'trend',
];

const PRODUCT_DISTILLED_KEYWORDS = {
  'Restaurant.Type-1': RESTAURANT_DISTILLED,
  'Gym.Type-1': GYM_DISTILLED,
};

/**
 * Determine if a query will hit the Distilled-GenAI fast path or needs LLM.
 * @returns 'distilled' | 'llm'
 */
export function getQuerySource(query, productType) {
  const q = (query || '').toLowerCase();
  const keywords = PRODUCT_DISTILLED_KEYWORDS[productType] || [];
  for (const kw of keywords) {
    if (q.includes(kw)) return 'distilled';
  }
  return 'llm';
}

/**
 * Get tooltip text for a query source.
 */
export function getSourceTooltip(source) {
  if (source === 'distilled') {
    return 'SQL Intelligence: Distilled-GenAI — Pre-built SQL pattern, executes instantly against your database (no LLM call)';
  }
  return 'SQL Intelligence: LLM — Query will be sent to the LLM to generate SQL dynamically';
}

/**
 * Get bulb color for source indicator.
 */
export function getSourceColor(source) {
  return source === 'distilled' ? '#4CAF50' : '#2196F3';
}

export default PRODUCT_DISTILLED_KEYWORDS;
